'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTimer3 = function MdTimer3(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.2 17.4c-1.2 0-2.4 0.6-2.4 1.8 0 1.1 0.7 1.2 1.6 1.6 0.4 0.1 0.8 0.3 1.4 0.4 0.8 0.1 1.5 0.4 2.2 0.6s1.3 0.6 1.8 0.9 0.7 0.8 1 1.3 0.4 0.9 0.4 1.6c0 2.4-1.6 3.5-3.5 4.1-0.7 0.2-1.5 0.3-2.4 0.3-2.8 0-4.9-1.1-5.7-3-0.2-0.6-0.4-1.1-0.4-1.8h3.1c0 1.6 1.5 2.4 3.1 2.4 1.4 0 2.6-0.5 2.6-1.8 0-1.1-0.7-1.3-1.5-1.7-0.4-0.1-1-0.3-1.7-0.4-1.4-0.3-2.7-0.8-3.7-1.5-0.8-0.6-1.4-1.5-1.4-2.8 0-2.2 1.6-3.5 3.3-4.1 0.7-0.2 1.4-0.3 2.2-0.3 3.2 0 5.9 1.5 5.9 4.6h-3.3c0-1-0.6-1.7-1.5-1.9-0.3-0.1-0.7-0.3-1.1-0.3z m-12.4 2.4c1.9 0.7 3.3 2 3.3 4.5 0 2-0.7 3.4-1.9 4.3-1.1 0.9-2.7 1.6-4.7 1.6-3.6 0-6.5-2-6.5-5.7h3.3c0 0.9 0.3 1.8 0.9 2.2 0.5 0.4 1.3 0.8 2.3 0.8 2.1 0 3.3-1.1 3.3-3.2 0-2.2-1.3-3.2-3.6-3.2h-2v-2.6h1.9c1.6 0 2.8-0.6 3.2-1.8 0.2-0.4 0.2-0.8 0.2-1.2 0-2-1-3-3-3-1.4 0-2.3 0.6-2.8 1.6-0.2 0.3-0.2 0.7-0.2 1.1h-3.3c0-2.6 1.8-4.2 3.7-5 0.8-0.2 1.7-0.4 2.6-0.4 3.8 0 6.3 1.9 6.3 5.7 0 2.2-1.5 3.5-3 4.3z' })
        )
    );
};

exports.default = MdTimer3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/timer-3.js
// module id = 2868
// module chunks = 0